import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';

export interface LabelProps extends ComponentPropsWithRef<'label'> {
  /** Dodaje czerwona gwiazdke oznaczajaca pole wymagane. */
  required?: boolean;
}

/** Etykieta pola formularza. */
export function Label({ className, required, children, ...props }: LabelProps) {
  return (
    <label className={cn('text-fg-muted block text-[0.8125rem] font-medium', className)} {...props}>
      {children}
      {required && (
        <span className="text-danger-500 ml-0.5" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
